/* ============================================================
   TENUTA GRIECI · tg-a11y.js — 15/09/2026
   Livello di accessibilità e scorrimento, sopra theme.js/tg-upgrades.js.
   1) Menu: inerte da chiuso, focus dentro all'apertura, trappola, ritorno
   2) Scena orizzontale: il focus da tastiera porta in vista il pannello
   3) Trackpad laterale: non dirotta più le aree a scorrimento orizzontale
   4) Meteo: niente annunci ripetuti, frasi in lingua, niente 31° finti
   5) Cursore: etichette nella lingua della pagina
   6) Pausa per video hero e nastro della Tenuta (WCAG 2.2.2)
   7) Slide della Tenuta: frecce + swipe su touch
   ============================================================ */
(function(){
  'use strict';
  var LANG = (document.documentElement.lang || 'it').slice(0,2).toLowerCase();
  var IT = LANG === 'it';
  var T = IT ? {
    pauseVideo:'Metti in pausa il video', playVideo:'Riproduci il video',
    pauseMotion:'Ferma il nastro', playMotion:'Riavvia il nastro',
    prev:'Precedente', next:'Successivo', buy:'Riserva', discover:null
  } : {
    pauseVideo:'Pause video', playVideo:'Play video',
    pauseMotion:'Pause the ribbon', playMotion:'Play the ribbon',
    prev:'Previous', next:'Next', buy:'Reserve', discover:null
  };
  var DESK = matchMedia('(min-width: 951px)');
  var REDUCE = matchMedia('(prefers-reduced-motion: reduce)').matches;
  var FOCUSABLE = 'a[href],button:not([disabled]),input:not([disabled]),select,textarea,[tabindex]:not([tabindex="-1"])';

  function lenisTo(y, opts){
    var l = window.__lenis;
    if(l && typeof l.scrollTo === 'function'){ try{ l.scrollTo(y, opts || {immediate:true}); return; }catch(e){} }
    window.scrollTo({top:y, behavior:(opts && !opts.immediate && !REDUCE) ? 'smooth' : 'auto'});
  }
  function ready(fn){ if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn); else fn(); }
  var PAUSE_SVG = '<svg viewBox="0 0 16 16" aria-hidden="true" focusable="false"><path d="M5 3h2v10H5zM9 3h2v10H9z" fill="currentColor"/></svg>';
  var PLAY_SVG  = '<svg viewBox="0 0 16 16" aria-hidden="true" focusable="false"><path d="M5 3l8 5-8 5z" fill="currentColor"/></svg>';

  /* ---------- 3 · TRACKPAD LATERALE ----------
     theme.js converte ogni gesto orizzontale in scroll verticale, su tutta la
     finestra. Qui, in fase di capture, lo si ferma prima che arrivi a lui
     quando: non c'è la scena orizzontale (pagine diverse dalla home), oppure
     il gesto parte da un'area che scorre davvero di lato. Il default resta:
     l'area scorre in modo nativo. Registrato subito, fuori da ready(). */
  function scrollsX(el){
    for(; el && el !== document.body && el.nodeType === 1; el = el.parentElement){
      if(el.scrollWidth > el.clientWidth + 1){
        var ox = getComputedStyle(el).overflowX;
        if(ox === 'auto' || ox === 'scroll') return true;
      }
    }
    return false;
  }
  window.addEventListener('wheel', function(e){
    if(e.ctrlKey) return;
    if(Math.abs(e.deltaX) <= Math.abs(e.deltaY)) return;
    if(!document.getElementById('scene') || scrollsX(e.target)) e.stopImmediatePropagation();
  }, {capture:true, passive:true});

  ready(function(){
    try{ initMenu(); }catch(e){}
    try{ initSceneFocus(); }catch(e){}
    try{ initWeather(); }catch(e){}
    try{ initCursor(); }catch(e){}
    try{ initHeroPause(); }catch(e){}
    waitTge(function(){
      try{ initMarqueePause(); }catch(e){}
      try{ initSlideNav(); }catch(e){}
    });
  });

  /* ---------- 1 · MENU ---------- */
  function initMenu(){
    var toggle = document.getElementById('menuToggle');
    var overlay = document.getElementById('menuOverlay');
    if(!toggle || !overlay) return;
    var lastFocus = null;
    function isOpen(){ return toggle.getAttribute('aria-expanded') === 'true'; }
    function sync(){
      if(isOpen()){
        overlay.inert = false; overlay.removeAttribute('aria-hidden');
        setTimeout(function(){
          var first = overlay.querySelector('.menu__item-link');
          if(first && isOpen()) first.focus({preventScroll:true});
        }, 320);
      } else {
        var inside = overlay.contains(document.activeElement);
        overlay.inert = true; overlay.setAttribute('aria-hidden','true');
        if(inside || document.activeElement === document.body){
          (lastFocus && document.contains(lastFocus) ? lastFocus : toggle).focus({preventScroll:true});
        }
      }
    }
    toggle.addEventListener('click', function(){ if(!isOpen()) lastFocus = toggle; }, true);
    new MutationObserver(sync).observe(toggle, {attributes:true, attributeFilter:['aria-expanded']});
    overlay.inert = !isOpen();
    if(!isOpen()) overlay.setAttribute('aria-hidden','true');
    document.addEventListener('keydown', function(e){
      if(e.key !== 'Tab' || !isOpen()) return;
      var f = [toggle].concat([].slice.call(overlay.querySelectorAll(FOCUSABLE)));
      if(f.length < 2) return;
      var first = f[0], last = f[f.length-1], a = document.activeElement;
      if(f.indexOf(a) === -1){ e.preventDefault(); f[1].focus(); return; }
      if(e.shiftKey && a === first){ e.preventDefault(); last.focus(); }
      else if(!e.shiftKey && a === last){ e.preventDefault(); first.focus(); }
    });
  }

  /* ---------- 2 · FOCUS NELLA SCENA ORIZZONTALE ----------
     Il track si muove con transform: il browser non sa portare in vista un
     link di un pannello lontano. Stesso calcolo della rail capitoli
     (1 px verticale = 1 px orizzontale). */
  function initSceneFocus(){
    var track = document.getElementById('track'), scene = document.getElementById('scene');
    if(!track || !scene) return;
    track.addEventListener('focusin', function(e){
      if(!DESK.matches) return;
      var panel = e.target.closest('#track > .panel');
      if(!panel) return;
      scene.scrollLeft = 0; if(track.parentElement) track.parentElement.scrollLeft = 0;
      var r = panel.getBoundingClientRect();
      if(r.left >= -1 && r.right <= window.innerWidth + 1) return;
      var maxX = track.scrollWidth - window.innerWidth;
      if(maxX <= 0) return;
      var x = Math.min(maxX, Math.max(0, panel.offsetLeft - Math.max(0, (window.innerWidth - panel.offsetWidth) / 2)));
      var sp = (scene.parentElement && scene.parentElement.classList.contains('pin-spacer')) ? scene.parentElement : scene;
      var startY = sp.getBoundingClientRect().top + (window.scrollY || window.pageYOffset || 0);
      lenisTo(startY + x, {immediate:true});
    });
  }

  /* ---------- 4 · METEO ---------- */
  var PHRASES_IT = {
    'Clear night over the groves':'Notte limpida sugli ulivi',
    'Dry summer light':'Luce limpida sulla tenuta',
    'Soft night over the estate':'Notte quieta sulla tenuta',
    'Soft Mediterranean light':'Luce mediterranea morbida',
    'Veiled light over the groves':'Luce velata sugli ulivi',
    'Mist settling on the hills':'Foschia sulle colline',
    'Morning mist over the estate':'Nebbia del mattino sulla tenuta',
    'Rain feeding the olive trees':'Pioggia sugli ulivi',
    'Rare frost on the hills':'Brina sulle colline',
    'Summer storm over the valley':'Temporale sulla valle',
    'Night over the estate':'Notte sulla tenuta',
    'Light over the estate':'Luce sulla tenuta'
  };
  /* in inglese si corregge solo il riferimento all'estate, sbagliato d'inverno */
  var PHRASES_EN = { 'Dry summer light':'Clear light over the estate', 'Summer storm over the valley':'Storm over the valley' };

  function initWeather(){
    var el = document.getElementById('estateNow');
    if(!el) return;
    el.removeAttribute('aria-live');
    var map = IT ? PHRASES_IT : PHRASES_EN, live = null, busy = false;
    function fix(){
      if(busy) return; busy = true;
      var w = document.createTreeWalker(el, NodeFilter.SHOW_TEXT), n;
      while((n = w.nextNode())){
        var t = n.nodeValue;
        for(var k in map){ if(t.indexOf(k) !== -1){ t = t.split(k).join(map[k]); } }
        if(t !== n.nodeValue) n.nodeValue = t;
      }
      if(live !== null && el.textContent.indexOf(live + '\u00b0') !== -1) el.classList.add('tg-wx-ready');
      busy = false;
    }
    new MutationObserver(fix).observe(el, {childList:true, subtree:true, characterData:true});
    fix();
    /* La temperatura resta nascosta finché non arriva il dato vero: prima il
       tema mostrava la temperatura di riserva (31°) anche d'inverno. */
    var lat = el.dataset.lat || '41.135', lng = el.dataset.lng || '15.066';
    fetch('https://api.open-meteo.com/v1/forecast?latitude=' + lat + '&longitude=' + lng + '&current=temperature_2m,weather_code,is_day&timezone=Europe%2FRome')
      .then(function(r){ if(!r.ok) throw 0; return r.json(); })
      .then(function(d){ live = Math.round(d.current.temperature_2m); fix(); })
      .catch(function(){});
  }

  /* ---------- 5 · CURSORE ---------- */
  function initCursor(){
    var sp = document.querySelector('#cursor span');
    if(!sp) return;
    var discover = sp.textContent.trim();          /* già tradotto da locales */
    new MutationObserver(function(){
      var t = sp.textContent;
      if(t === 'Buy') sp.textContent = T.buy;
      else if(t === 'Discover' && discover && discover !== 'Discover') sp.textContent = discover;
    }).observe(sp, {childList:true, characterData:true, subtree:true});
  }

  /* ---------- 6 · PAUSA ---------- */
  function pauseBtn(cls){
    var b = document.createElement('button');
    b.type = 'button'; b.className = 'tg-pause ' + cls;
    return b;
  }
  function setBtn(b, playing, labels){
    b.innerHTML = playing ? PAUSE_SVG : PLAY_SVG;
    b.setAttribute('aria-label', playing ? labels[0] : labels[1]);
    b.setAttribute('aria-pressed', playing ? 'false' : 'true');
  }
  function initHeroPause(){
    var v = document.querySelector('.hero__video video');
    if(!v) return;
    var host = v.closest('.panel') || v.closest('.hero') || v.parentElement;
    if(getComputedStyle(host).position === 'static') host.style.position = 'relative';
    var b = pauseBtn('tg-pause--hero');
    var labels = [T.pauseVideo, T.playVideo];
    function upd(){ setBtn(b, !v.paused, labels); }
    b.addEventListener('click', function(){
      if(v.paused){ var p = v.play(); if(p && p.catch) p.catch(function(){}); } else { v.pause(); }
    });
    v.addEventListener('play', upd); v.addEventListener('pause', upd);
    host.appendChild(b); upd();
  }

  function waitTge(fn){
    if(!document.querySelector('[data-tge-root]')) return;
    var n = 0;
    (function poll(){
      if(document.querySelector('.tge.js-motion') && window.gsap) return fn();
      if(++n < 60) setTimeout(poll, 100);
    })();
  }

  function initMarqueePause(){
    document.querySelectorAll('[data-tge-marquee]').forEach(function(track){
      var band = track.closest('.tge-marquee');
      if(!band || band.nextElementSibling && band.nextElementSibling.classList.contains('tg-pause')) return;
      var paused = false;
      var b = pauseBtn('tg-pause--band');
      var labels = [T.pauseMotion, T.playMotion];
      /* tg-estate.js riavvia il tween entrando in vista e ne cambia la velocità
         con lo scroll: finché è in pausa, lo si tiene fermo a ogni frame. */
      function hold(){ if(!paused) return; window.gsap.getTweensOf(track).forEach(function(t){ if(!t.paused()) t.pause(); }); }
      b.addEventListener('click', function(){
        paused = !paused;
        window.gsap.getTweensOf(track).forEach(function(t){ paused ? t.pause() : t.play(); });
        setBtn(b, !paused, labels);
      });
      window.gsap.ticker.add(hold);
      band.parentNode.insertBefore(b, band.nextSibling);
      setBtn(b, true, labels);
    });
  }

  /* ---------- 7 · SLIDE DELLA TENUTA ---------- */
  var ARROW_L = '<svg viewBox="0 0 16 16" fill="none" aria-hidden="true" focusable="false"><path d="M10.47 12.47a.75.75 0 0 1-.94 0l-4-4a.75.75 0 0 1 0-.94l4-4a.66.66 0 0 1 .94.94L6.94 8l3.53 3.53a.66.66 0 0 1 0 .94Z" fill="currentColor"/></svg>';
  var ARROW_R = '<svg viewBox="0 0 16 16" fill="none" aria-hidden="true" focusable="false"><path d="M5.53 3.53a.75.75 0 0 1 .94 0l4 4a.75.75 0 0 1 0 .94l-4 4a.66.66 0 0 1-.94-.94L9.06 8 5.53 4.47a.66.66 0 0 1 0-.94Z" fill="currentColor"/></svg>';

  function initSlideNav(){
    document.querySelectorAll('[data-tge-slides]').forEach(function(area){
      var slides = area.querySelectorAll('.tge-slide');
      var pag = area.querySelector('[data-tge-pag-static]');
      if(slides.length < 2 || !pag || pag.querySelector('[data-tg-slide]')) return;
      function mk(dir){
        var b = document.createElement('button');
        b.type = 'button'; b.className = 'tge-pag__btn tge-l1'; b.setAttribute('data-tg-slide', dir);
        b.setAttribute('aria-label', dir < 0 ? T.prev : T.next);
        b.innerHTML = dir < 0 ? ARROW_L : ARROW_R;
        return b;
      }
      var prev = mk(-1), next = mk(1);
      pag.insertBefore(prev, pag.firstChild); pag.appendChild(next);

      function cur(){ for(var i = 0; i < slides.length; i++){ if(slides[i].classList.contains('is-on')) return i; } return 0; }
      function go(i){
        if(!area.classList.contains('is-ready')) return;
        i = Math.max(0, Math.min(slides.length - 1, i));
        var top = area.getBoundingClientRect().top + (window.scrollY || window.pageYOffset || 0);
        var run = Math.max(0, area.offsetHeight - window.innerHeight);
        lenisTo(top + run * ((i + 0.5) / slides.length), REDUCE ? {immediate:true} : {duration:0.8});
      }
      function upd(){
        var i = cur();
        prev.disabled = i <= 0; next.disabled = i >= slides.length - 1;
      }
      prev.addEventListener('click', function(){ go(cur() - 1); });
      next.addEventListener('click', function(){ go(cur() + 1); });
      var mo = new MutationObserver(upd);
      slides.forEach(function(s){ mo.observe(s, {attributes:true, attributeFilter:['class']}); });
      upd();

      /* swipe laterale su touch: una slide per gesto */
      if(navigator.maxTouchPoints > 0){
        var screen = area.querySelector('.tge-screen') || area, x0 = 0, y0 = 0, lock = null;
        screen.addEventListener('touchstart', function(e){
          if(e.touches.length !== 1){ lock = 'n'; return; }
          x0 = e.touches[0].clientX; y0 = e.touches[0].clientY; lock = null;
        }, {passive:true});
        screen.addEventListener('touchmove', function(e){
          if(!area.classList.contains('is-ready') || lock === 'y' || lock === 'n') return;
          var dx = e.touches[0].clientX - x0, dy = e.touches[0].clientY - y0;
          if(lock === null){
            if(Math.abs(dx) < 10 && Math.abs(dy) < 10) return;
            lock = Math.abs(dx) > Math.abs(dy) ? 'x' : 'y';
          }
          if(lock === 'x' && e.cancelable) e.preventDefault();
        }, {passive:false});
        screen.addEventListener('touchend', function(e){
          if(lock !== 'x') return;
          var dx = e.changedTouches[0].clientX - x0;
          if(Math.abs(dx) > 40) go(cur() + (dx < 0 ? 1 : -1));
          lock = null;
        }, {passive:true});
      }
    });
  }
})();
